"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "m1.485 11.993.497.035c1.26.098 3.696.365 4.374 1.01a.458.458 0 0 1 .141.373l-.035.327-.023.172 7.949 1.771c1.282.322 1.958.945 2.14 1.98l.026.187 2.971-.744a2.993 2.993 0 0 1 3.426 1.581.46.46 0 0 1-.155.59l-.065.035-5.041 2.3-.839.341c-1.825.736-2.76 1.048-3.573 1.048-.532 0-1.01-.133-1.65-.368l-.249-.093-6.568-2.195-.168.528a.457.457 0 0 1-.352.31l-.083.008h-2.75a.459.459 0 0 1-.45-.377L1 20.73v-8.278a.457.457 0 0 1 .485-.458Zm4.799 2.824c-.246 1.26-.643 2.73-.985 3.91l-.218.736 6.605 2.21.477.178c1.17.416 1.655.343 4.584-.85l.578-.237 4.544-2.072a2.077 2.077 0 0 0-1.961-.73l-.161.033-4.746 1.19a3.193 3.193 0 0 1-1.2.07l-.207-.035-3.977-.799a.458.458 0 0 1-.359-.54.457.457 0 0 1 .457-.37l.082.008 3.975.8c.265.053.54.057.807.014l.198-.04.88-.22c-.053-.787-.415-1.19-1.296-1.446l-.183-.05-7.894-1.76Zm-4.369-1.872v7.324h1.958l.354-1.153c.465-1.554 1.144-3.988 1.329-5.519-.51-.247-1.808-.475-3.118-.605l-.523-.047Zm13.47-11.248a2.916 2.916 0 0 1 2.385-.655c1.413.24 2.477 1.609 2.477 3.185 0 .831-.258 1.55-.732 2.113l-.134.149-4.303 4.487a.46.46 0 0 1-.59.059l-.07-.06-4.301-4.486a3.118 3.118 0 0 1-.869-2.176c0-1.662 1.068-3.031 2.48-3.271a2.924 2.924 0 0 1 2.386.655c.252.214.465.465.635.744.17-.28.383-.53.635-.744Zm-3.155.222c-.116 0-.232.01-.348.03-.979.165-1.716 1.145-1.716 2.278 0 .586.176 1.094.487 1.484l.123.14 3.973 4.142L18.72 5.85a2.23 2.23 0 0 0 .61-1.538c0-1.218-.738-2.2-1.715-2.363a1.988 1.988 0 0 0-1.64.449 2.203 2.203 0 0 0-.77 1.689.459.459 0 1 1-.916 0c0-.66-.28-1.275-.767-1.69a1.99 1.99 0 0 0-1.293-.48Z",
    clipRule: "evenodd"
  })]
});